import {Component, Input} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-popin',
  templateUrl: './popin.component.html',
  styleUrls: ['./popin.component.css']
})
export class PopinComponent {

  @Input()
  messageError: string;
  @Input()
  path: string;
  @Input()
  titre: string;
  @Input()
  clear: boolean;

  constructor(private router: Router) {
  }

  masquer() {
    if (this.clear) {
      localStorage.clear();
    }
    this.router.navigate([this.path]);
  }
}



// WEBPACK FOOTER //
// ./src/app/popin/popin.component.ts